<template lang="pug">
  el-dialog(title="查看详情", :close-on-click-modal='false', :visible.sync='visible' :modal-append-to-body='false')
    el-form(:model='dataForm', ref='dataForm',label-suffix=":"  label-width='100px')
      el-form-item(label='姓名', prop='name')
        <span>{{dataForm.name}}</span>
      el-form-item(label='账户属性', prop='accountType')
        <span>{{dataForm.accountType===0?'一般账户':'青少年账户'}}</span>
      el-form-item(label='会员账号', prop='mobile')
        <span>{{dataForm.mobile}}</span>
      el-form-item(label='证件类型')
        <span>{{dataForm.certificateTypeName}}</span>
      //- el-form-item(label='证件号码')
      el-form-item(label='证件号码')
        <span>{{dataForm.idCard}}</span>
      el-form-item(label='出生日期', prop='birthday')
        <span>{{dataForm.birthday}}</span>
      el-form-item(label='性　　别')
        <span>{{dataForm.gender}}</span>
      el-form-item(label='我是')
        <span>{{dataForm.professionalName}}</span>
      el-form-item(label='常住地')
        <span>{{dataForm.locationAddress}}</span>

      el-form-item(label='个人级别', prop='level')
        <span>{{dataForm.level}}</span>
      //- el-form-item(label='专业运动员', prop='professionalName')
      //-   <span>{{dataForm.professionalName}}</span>
      el-form-item(label='会员类别', prop='type')
        <span>{{dataForm.type}}</span>
      el-form-item(label='主办方', prop='orgId')
        <span>{{dataForm.orgId}}</span>
      el-form-item(label='身份属性', prop='identity')
        <span>{{dataForm.identity}}</span>
      el-form-item(label='头像', prop='headImg')
        <img :src="imageUrl" :onerror="defaultImg" style="width:100px;height:100px"/>
      el-form-item(label='昵称', prop='identity')
        <span>{{dataForm.nickname}}</span>
      el-form-item(label='俱乐部', prop='identity')
        <span>{{dataForm.clubName||'未加入俱乐部'}}</span>
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 返回
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      imageUrl: '',
      defaultImg: require('../img/img.jpg'),
      dataForm: {
         id: 0,
         name: '',
         mobile: '',
         idCard: '',
         birthday: null,
         gender: null,
         level: null,
         type: null,
         orgId: null,
         identity: null,
         headImg: '',
         nickname: '',
         clubName: '',
         certificateTypeName: '', // 证件类型
         professionalName: '', // 我是
         provinceName: '', // 省
         cityName: '' // 市
      }
    }
  },
  methods: {  
    init1 (id) {
      this.dataForm.id = id || 0
      this.visible = true
          this.$http({
            url: this.$http.adornUrl(`/mbMember/getId/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
                    this.dataForm.name = data.bean.name
                    this.dataForm.mobile = data.bean.mobile
                    this.dataForm.idCard = data.bean.idCard
                    this.dataForm.birthday = data.bean.birthday
                    this.dataForm.accountType = data.bean.accountType
                    if (data.bean.gender === 0) {
                      this.dataForm.gender = '男'
                    } else if (data.bean.gender === 1) {
                      this.dataForm.gender = '女'
                    }
                this.dataForm.level = data.bean.level
                    // if (data.bean.professional === 0) {
                    //   this.dataForm.professional = '是'
                    // } else if (data.bean.professional === 1) {
                    //   this.dataForm.professional = '否'
                    // }
                    if (data.bean.type === 1) {
                      this.dataForm.type = '注册会员'
                    } else if (data.bean.type === 2) {
                      this.dataForm.type = '初始会员'
                    } else if (data.bean.type === 3) {
                      this.dataForm.type = '荣誉会员'
                    }
                    this.dataForm.orgId = data.bean.orgName
                    if (data.bean.identity === 1) {
                      this.dataForm.identity = '在职人员'
                    } else if (data.bean.identity === 2) {
                      this.dataForm.identity = '在校人员'
                    } else if (data.bean.identity === 3) {
                      this.dataForm.identity = '退休人员'
                    } else if (data.bean.identity === 4) {
                      this.dataForm.identity = '志愿者'
                    } else if (data.bean.identity === 5) {
                      this.dataForm.identity = '家长'
                    } else if (data.bean.identity === 6) {
                      this.dataForm.identity = '其他'
                    }
                    this.dataForm.headImg = data.bean.headImg
                    this.dataForm.nickname = data.bean.nickname
                    this.dataForm.clubName = data.bean.clubName
                    this.dataForm.certificateTypeName = data.bean.certificateTypeName // 证件类型
                    this.dataForm.professionalName = data.bean.professionalName // 我是
                    // this.dataForm.provinceName = data.bean.provinceName // 省
                    // this.dataForm.cityName = data.bean.cityName // 市
                    let str=""
                    JSON.parse(data.bean.locationAddress).map(item=>{str+=item.provinceName+item.cityName+' '})
                    this.dataForm.locationAddress=str
                    if (data.bean.imgUrl !== '' && data.bean.imgUrl != null) {
                      this.imageUrl = data.bean.imgUrl
                      // this.imageUrl = "data:image/png;base64,"+data.bean.imgUrl
                    } else {
                      this.imageUrl = require('../img/img.jpg')
                    }
          }
        })
      }
   }
 }
</script>
